import { createSlice } from "@reduxjs/toolkit";
import {
fetchBranches,
addBranch,
updateBranch,
deleteBranch,
} from "./branch.thunk";

const initialState = {
branches: [],
totalPages: 1,
currentPage: 1,
total: 0,
limit: 10,
loading: false,
error: null,
selectedBranch: null,
};

const branchSlice = createSlice({
name: "branches",
initialState,

reducers: {
setCurrentPage: (state, action) => {
state.currentPage = action.payload;
},


setSelectedBranch: (state, action) => {
  state.selectedBranch = action.payload;
},

clearSelectedBranch: (state) => {
  state.selectedBranch = null;
},


},

extraReducers: (builder) => {
builder


  /* ===== FETCH ===== */

  .addCase(fetchBranches.pending, (state) => {
    state.loading = true;
    state.error = null;
  })

  .addCase(fetchBranches.fulfilled, (state, action) => {
    state.loading = false;

    state.branches = action.payload.data;

    state.totalPages =
      action.payload.meta.total_pages;

    state.total =
      action.payload.meta.total;

    state.limit =
      action.payload.meta.limit || 10;
  })

  .addCase(fetchBranches.rejected, (state, action) => {
    state.loading = false;
    state.error = action.payload;
  })

  /* ===== ADD ===== */

  .addCase(addBranch.pending, (state) => {
    state.loading = true;
    state.error = null;
  })

  .addCase(addBranch.fulfilled, (state) => {
    state.loading = false;
  })

  .addCase(addBranch.rejected, (state, action) => {
    state.loading = false;
    state.error = action.payload;
  })

  /* ===== UPDATE ===== */

  .addCase(updateBranch.pending, (state) => {
    state.loading = true;
    state.error = null;
  })

  .addCase(updateBranch.fulfilled, (state) => {
    state.loading = false;
  })

  .addCase(updateBranch.rejected, (state, action) => {
    state.loading = false;
    state.error = action.payload;
  })

  /* ===== DELETE ===== */

  .addCase(deleteBranch.pending, (state) => {
    state.loading = true;
    state.error = null;
  })

  .addCase(deleteBranch.fulfilled, (state, action) => {
    state.loading = false;

    state.branches = state.branches.filter(
      (branch) => branch.id !== action.payload.id
    );
  })

  .addCase(deleteBranch.rejected, (state, action) => {
    state.loading = false;
    state.error = action.payload;
  });


},
});

export const {
setCurrentPage,
setSelectedBranch,
clearSelectedBranch,
} = branchSlice.actions;

export default branchSlice.reducer;
